import { Menu } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { UserStatus } from 'api/models';
import { Switcher } from 'components/atoms/switcher';
import { Member } from 'data/members/api';
import { TeamMembersTabsEnum } from './types';

const Wrapper = styled.div`
  align-items: center;
  display: flex;
`;

const Tabs = styled(Menu)`
  border-bottom: none;
  flex: 1;
`;

const SwitcherButton = styled(Switcher.Button)`
  height: 40px !important;
`;

export const TeamMemberTabs: FC<{
  tab: string;
  members: Member[];
  onChangeTab(key: TeamMembersTabsEnum): void;
}> = ({ tab, members, onChangeTab }) => {
  const handleTabChange = ({ key }) => {
    onChangeTab(key);
  };

  const activeUserCount = members.filter(
    ({ user }) => user.userStatus === UserStatus.Active,
  ).length;

  const invitedUserCount = members.filter(
    ({ user }) => user.userStatus === UserStatus.Invited,
  ).length;

  const deactivatedUserCount = members.filter(
    ({ user }) => user.userStatus === UserStatus.Inactive,
  ).length;

  return (
    <Wrapper>
      <Tabs selectedKeys={[tab]} onClick={handleTabChange} mode="horizontal">
        <Switcher
          value={tab}
          onChange={(e) => handleTabChange({ key: e.target.value })}
          activeColor="black"
        >
          <SwitcherButton value={TeamMembersTabsEnum.Active}>
            <FormattedMessage id={TeamMembersTabsEnum.Active} />{' '}
            {activeUserCount > 0 && <>({activeUserCount})</>}
          </SwitcherButton>
          <SwitcherButton value={TeamMembersTabsEnum.Invited}>
            <FormattedMessage id={TeamMembersTabsEnum.Invited} />{' '}
            {invitedUserCount > 0 && <>({invitedUserCount})</>}
          </SwitcherButton>
          <SwitcherButton value={TeamMembersTabsEnum.Deactivated}>
            <FormattedMessage id={TeamMembersTabsEnum.Deactivated} />{' '}
            {deactivatedUserCount > 0 && <>({deactivatedUserCount})</>}
          </SwitcherButton>
        </Switcher>
      </Tabs>
    </Wrapper>
  );
};
